import React from "react";
import { NavLink } from "react-router-dom";
import styled, { css } from "styled-components";

export interface Icon {
	default: string;
	active: string;
}

const StyledNavLink = styled(NavLink)<{ $icon?: Icon }>`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary.greyText};
  font-size: 14px;
  font-weight: normal;
  background-size: 1.5em;
  padding-left: 2em;

  transition: color, background-image 0.2s ease-out;

  ${(props: { $icon?: Icon }) => {
		if (props?.$icon) {
			return css`
        background: transparent url(${props.$icon.default}) no-repeat center left;
        &.active,
        &:hover {
          background-image: url(${props.$icon.active});
        }
      `;
		}
	}}

  &.active,
  &:hover {
    color: ${({ theme }) => theme.colors.primary.green};
    font-weight: 600;
  }
`;

const LinkWithIcon = ({
	className,
	to,
	text,
	icon,
	onClick = () => {},
}: {
	className?: string;
	to: string;
	text: string;
	icon?: Icon;
	onClick?: React.MouseEventHandler;
}) => {

	return (
		<>
			<StyledNavLink
				to={to}
				className={className}
				$icon={icon}
				onClick={onClick}
			>
				{text}
			</StyledNavLink>
		</>
	);
};

export { LinkWithIcon };
